import { FC } from 'react';

import { Button } from 'antd';
import cs from 'classnames';
import { format } from 'date-fns';
import { motion } from 'framer-motion';

import { deserializeSlot } from 'utils/dateUtils';

import { InterviewSlotSerialized } from 'types/interviewSlots';

import { ReactComponent as EditIcon } from 'assets/icons/edit-square.svg';

import { useTranslation } from 'react-i18next';
import styles from './SelectedSlot.module.scss';

interface SelectedSlotProps {
  slot: InterviewSlotSerialized;
  onEdit: () => void;
  disabled: boolean;
}

const SelectedSlot: FC<SelectedSlotProps> = ({ slot, onEdit, disabled }) => {
  const { t } = useTranslation()

  const slotDate = deserializeSlot(slot);
  const formatSlotDate = (date: Date) => format(date, 'yyyy-MM-dd');
  const formatSlotTime = (date: Date) => format(date, 'hh:mm aa');

  return (
    <motion.div
      layout
      initial={{ opacity: 0, height: 0, borderWidth: 1 }}
      animate={{
        opacity: 1,
        height: 'auto',
        borderWidth: 1,
        transition: { duration: 0.3, ease: 'easeInOut' }
      }}
      exit={{
        opacity: 0,
        height: 0,
        transition: { duration: 0.2, ease: 'easeInOut' },
        padding: 0,
        border: 'none',
        margin: 0
      }}
      className={styles.slotItem}
    >
      <div className={styles.slotContent}>
        <Button
          type="text"
          icon={<EditIcon />}
          onClick={onEdit}
          className={cs(styles.actionButton, styles.edit)}
          disabled={disabled}
        />
        <div className={styles.slotDate}>
          <span className={styles.dateValue}>
            {formatSlotDate(slotDate.start)}
          </span>
          <span className={styles.dateLabel}>{t('common.label.interviewDate')}</span>
        </div>
        <div className={styles.slotTime}>
          <span className={styles.timeValue}>
            {formatSlotTime(slotDate.start)}
          </span>
          <span className={styles.timeLabel}>{t('common.label.interviewTime')}</span>
        </div>
      </div>
    </motion.div>
  );
};

export default SelectedSlot;
